var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 90.665,
    viewBox: "0 0 128 90.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11146",
    "data-name": "Group 11146",
    transform: "translate(3203.151 15651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6137",
    "data-name": "Path 6137",
    d: "M377.03,398.44h17.413v5.333H377.03Z",
    transform: "translate(-3509.488 -15974.782)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6138",
    "data-name": "Path 6138",
    d: "M219.534,257.931H195.375V252.6h18.747a45.391,45.391,0,0,0-45.254-42.667h-72V252.6h16.508v5.333H91.536V204.6h77.333a50.725,50.725,0,0,1,50.667,50.667Z",
    transform: "translate(-3294.687 -15828.938)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6139",
    "data-name": "Path 6139",
    d: "M243.27,398.44h17.388v5.333H243.27Z",
    transform: "translate(-3408.85 -15974.782)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6140",
    "data-name": "Path 6140",
    d: "M312.889,387.478a10.667,10.667,0,1,1,10.667-10.667A10.677,10.677,0,0,1,312.889,387.478Zm0-16a5.333,5.333,0,1,0,5.333,5.333A5.34,5.34,0,0,0,312.889,371.478Z",
    transform: "translate(-3453.205 -15950.48)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6141",
    "data-name": "Path 6141",
    d: "M446.679,387.478a10.667,10.667,0,1,1,10.667-10.667A10.677,10.677,0,0,1,446.679,387.478Zm0-16a5.333,5.333,0,1,0,5.333,5.333A5.34,5.34,0,0,0,446.679,371.478Z",
    transform: "translate(-3553.865 -15950.48)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6142",
    "data-name": "Path 6142",
    d: "M179.089,387.478a10.667,10.667,0,1,1,10.667-10.667A10.677,10.677,0,0,1,179.089,387.478Zm0-16a5.333,5.333,0,1,0,5.333,5.333A5.34,5.34,0,0,0,179.089,371.478Z",
    transform: "translate(-3352.536 -15950.48)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6143",
    "data-name": "Path 6143",
    d: "M238.691,279.791H145.36V258.458h74.666a18.688,18.688,0,0,1,18.666,18.666Zm-88-5.334h82.4a13.356,13.356,0,0,0-13.065-10.667H150.691Z",
    transform: "translate(-3335.183 -15869.461)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6144",
    "data-name": "Path 6144",
    d: "M393.08,161.71h5.333v15.95H393.08Z",
    transform: "translate(-3521.565 -15796.668)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6145",
    "data-name": "Path 6145",
    d: "M113.05,441.54H230.383v5.333H113.05Z",
    transform: "translate(-3310.875 -16007.209)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6146",
    "data-name": "Path 6146",
    d: "M317.881,110.707a2.667,2.667,0,0,1-2.482-1.693,5.478,5.478,0,0,0-1.76-2.471c-2.476.419-5.646-1.38-7.964-3.07l-3.156,4.615a2.668,2.668,0,0,1-3.458.846l-6-3.208a2.667,2.667,0,0,1,2.516-4.7l3.89,2.081,3.43-5.013a2.661,2.661,0,0,1,1.867-1.14,2.69,2.69,0,0,1,2.091.64c2.182,1.908,5.1,3.69,6.047,3.69h.021c3.584-.591,6.26,2.75,7.443,5.792a2.668,2.668,0,0,1-2.486,3.636Z",
    transform: "translate(-3445.251 -15747.93)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/Train.61b929c8cfe072ef2754a34e094c77be.svg";
export { ForwardRef as ReactComponent };